import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	Modal,
	Button,
	FileImport,
	ErrorBanner,
	ProgressIndicator
} from "rhombus-react";

import { closeModal } from "reducers/Modal";
import { bulkImportSocialCreatives, resetBulkImportErrors } from "reducers/Social";
import { MODAL_TYPES } from "utils/constants";

import "./ImportSocialCreativesModal.css";

export default function ImportSocialCreativesModal(props){
	const dispatch = useDispatch()
		, [formData, setFormData] = useState(null)
		, [isImporting, setIsImporting] = useState(false)
		, { isOpen, libraryId, hasError, errorObj } = useSelector((state) => {
			return {
				isOpen:     state.modal.isOpen && state.modal.modalType === MODAL_TYPES.socialCreativeImport,
				libraryId:  state.libraryProperties?.id,
				hasError:   state.social?.bulkImportErrors?.hasError || false,
				errorObj:   state.social?.bulkImportErrors?.errorObj || {},
			};
		});

	useEffect(()=> {
		setIsImporting(false);
		setFormData(null);
	}, [isOpen]);

	if(!isOpen){
		return null;
	}

	let title = "Import Social Creatives"
		, errorTitle = "Invalid sheet format. Please ensure you're uploading a properly formatted sheet. Try re-downloading the template if the error persists."
		, errorMessage = errorObj?.description || ""
		, $errorBanner = hasError ? <ErrorBanner title={errorTitle} messages={[errorMessage]} /> : null
		, isFileSelected = formData !== null;

	function onClose(){
		dispatch(closeModal());
		if(hasError){
			dispatch(resetBulkImportErrors());
		}
	}

	function handleImport(){
		if(formData){
			setIsImporting(true);
			dispatch(bulkImportSocialCreatives(libraryId, formData)).then((resp)=> {
				setIsImporting(false);
				if(resp && resp.success){
					dispatch(closeModal());
				}
			});
		}
	}

	function handleFileSelectionChange(changeList){
		if(changeList && changeList.length){
			let [importedData] = changeList
				, { formData } = importedData
				, importFile = formData.get("file")
				, newFormData = new FormData()
			;
			newFormData.append("file", importFile);
			setFormData(newFormData);
		}
	}

	const fileImportProps = {
		label: "Select File",
		required: true,
		inputPlaceholder: "Click browse to select spreadsheet",
		useField: false,
		multipleFiles: false,
		onChange: handleFileSelectionChange,
		disabled: isImporting,
		accept: ".xlsm,.xlsx",
	};

	function renderContent(){
		return (
			<div className="import-social-creatives">
				<ProgressIndicator isLoading={isImporting} />
				{$errorBanner}
				<FileImport {...fileImportProps} />
			</div>
		);
	}

	function renderFooter(){
		let importButtonProps = {
			theme: "green",
			onClick: handleImport,
			disabled: (!isFileSelected || isImporting),
		};

		return [
			<Button
				key="cancel"
				theme = "default"
				onClick = {onClose}
			>
				Cancel
			</Button>,
			<Button key="import" {...importButtonProps}>
				Import
			</Button>
		];
	}

	let bladeProps = {
		verticallyCenter: true,
	};

	const importModalProps = {
		title,
		type: "modal",
		className: "import-social-creatives-modal",
		xClose: true,
		allowFullScreen: false,
		bladeProps,
		renderContent,
		renderFooter,
		onClose,
	};

	return <Modal {...importModalProps} />;
}

ImportSocialCreativesModal.displayName = "ImportSocialCreativesModal";
